import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal } from '@offerzen/pinata-shame'

import { registerModal, hideModal as hideModalAction, destroyModal } from './reducers'
import { modalVisible } from './selectors'

const ModalRedux = ({ dispatchRegisterModal, dispatchDestroyModal, hideModal, visible, ...props }) => {
  useEffect(() => {
    dispatchRegisterModal()

    return () => {
      dispatchDestroyModal()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      hideModal={hideModal}
      visible={visible}
    />
  )
}

const makeMapStateToProps = () => {
  const visible = modalVisible()

  const mapStateToProps = (state, ownProps) => ({
    visible: visible(state, ownProps.name),
  })

  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchRegisterModal: () => dispatch(registerModal(ownProps.name)),
  dispatchDestroyModal: () => dispatch(destroyModal(ownProps.name)),
  hideModal: () => dispatch(hideModalAction(ownProps.name)),
})

export default connect(makeMapStateToProps, mapDispatchToProps)(ModalRedux)

ModalRedux.propTypes = {
  size: PropTypes.oneOf(['', 'default', 'small', 'medium', 'large']),
  onModalClose: PropTypes.func,
  preventClose: PropTypes.bool,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  dispatchRegisterModal: PropTypes.func.isRequired,
  dispatchDestroyModal: PropTypes.func.isRequired,
}
